module.exports = new __parcel__URL__("limewire_logo.2d2504ca.svg").toString();